import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const CheckoutCancel = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="checkout-cancel-page">
      <Card className="w-full max-w-md text-center">
        <CardContent className="pt-8 pb-8">
          <XCircle className="h-16 w-16 text-destructive mx-auto mb-4" />
          <h1 className="font-serif text-2xl font-bold text-foreground mb-2" data-testid="cancel-message">
            Payment Cancelled
          </h1>
          <p className="text-muted-foreground mb-6">
            Your payment was cancelled. Your cart items are still saved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/cart">
              <Button className="btn-primary" data-testid="return-to-cart-btn">Return to Cart</Button>
            </Link>
            <Link to="/products">
              <Button variant="outline">Continue Shopping</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutCancel;
